let contactSuccess = document.querySelector('.contact-form-success');

if (contactSuccess) {
		$(document).ready(function () {
				$('html, body').animate({
						scrollTop: $(contactSuccess).offset().top
				}, 'slow');
		});
}
